import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {
  constructor() {}

  private _currentModuleName$ = new BehaviorSubject<string>('');

  observeCurrentModuleName(): Observable<string> {
    return this._currentModuleName$.asObservable();
  }

  updateCurrentModuleName(name: string) {
    this._currentModuleName$.next(name);
  }
}
